<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="温度(℃)" prop="temperature" >
        <a-input v-model="form.temperature" placeholder="请输入温度(℃)" />
      </a-form-model-item>
      <a-form-model-item label="湿度(%)" prop="humidity" >
        <a-input v-model="form.humidity" placeholder="请输入湿度(%)" />
      </a-form-model-item>
      <a-form-model-item label="温度舒适度标签，如舒适" prop="tempComfortLabel" >
        <a-input v-model="form.tempComfortLabel" placeholder="请输入温度舒适度标签，如舒适" />
      </a-form-model-item>
      <a-form-model-item label="湿度舒适度标签，如湿润" prop="humidityComfortLabel" >
        <a-input v-model="form.humidityComfortLabel" placeholder="请输入湿度舒适度标签，如湿润" />
      </a-form-model-item>
      <a-form-model-item label="记录时间" prop="recordTime" >
        <a-date-picker style="width: 100%" v-model="form.recordTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEnvLog, addEnvLog, updateEnvLog } from '@/api/mibo/envLog'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        deviceId: null,

        temperature: null,

        humidity: null,

        tempComfortLabel: null,

        humidityComfortLabel: null,

        recordTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        temperature: [
          { required: true, message: '温度(℃)不能为空', trigger: 'blur' }
        ],
        humidity: [
          { required: true, message: '湿度(%)不能为空', trigger: 'blur' }
        ],
        tempComfortLabel: [
          { required: true, message: '温度舒适度标签，如舒适不能为空', trigger: 'blur' }
        ],
        humidityComfortLabel: [
          { required: true, message: '湿度舒适度标签，如湿润不能为空', trigger: 'blur' }
        ],
        recordTime: [
          { required: true, message: '记录时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceId: null,
        temperature: null,
        humidity: null,
        tempComfortLabel: null,
        humidityComfortLabel: null,
        recordTime: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEnvLog({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEnvLog(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEnvLog(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
